export enum Extension {
  Zip,
  Txt,
  Png,
  Jpg,
  Rar
}
